const csvSettings = {
  'Customer Name': {
    key: 'name',
    display: 'Customer Name'
  },
  'Customer Id': {
    key: 'customerId',
    display: 'Customer Id'
  },
  'Contact Name': {
    key: 'contactName',
    display: 'Contact Name'
  },
  'Contact Email': {
    key: 'email',
    display: 'Contact Email'
  },
  'Contact Phone': {
    key: 'phoneNumber',
    display: 'Contact Phone'
  },
  'Contact Address': {
    key: 'address',
    display: 'Contact Address'
  }
}

export default csvSettings



// WEBPACK FOOTER //
// ./src/customer/common/csvSettings.js